import React, { useEffect, useRef } from 'react';
import { Group } from 'three';
import { useThree } from 'react-three-fiber';
import Stick from '../../../components/xr/stick';
import { SYNC_STICK } from '../../../common/constants/socket-events';
import { useSocket } from '../../../hooks';

const ParticipantStick = () => {
  const { camera } = useThree();
  const Socket = useSocket();
  const stick = useRef<Group>(null);

  useEffect(() => {
    if (!Socket) return;

    const handleStickSync = ({ data }: any) => {
      stick.current?.position.copy(data.value);
      stick.current?.lookAt(camera.position);
    };

    Socket.on(SYNC_STICK, handleStickSync);

    return () => {
      Socket.off(SYNC_STICK, handleStickSync);
    };
  }, [Socket, camera]);

  return <Stick ref={stick} />;
};

export default ParticipantStick;
